export function filterValuesByKeys(values: Record<string, any>, keys: string[]) {
	return keys.reduce((acc: any, key: string) => {
		acc[key] = values[key];

		return acc;
	}, {} as any);
}
